import { CommonModule } from "@angular/common";

import { NgModule } from "@angular/core";

import { CdrInsightsBaseModule } from "@providers/tracking/cdr-core/cdr-insights/model/cdr-insights-base.module";
import { CdrInsightsService } from "@providers/tracking/cdr-core/cdr-insights/shared/cdr-insights.service";

import soliticsconfig from "@config/soliticsconfig";
/**
 * @author a.e.m
 * @version 1.0.0
 * @description modulo del tracker solitics
 *
 */
@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [],
})
export class SoliticsModule extends CdrInsightsBaseModule {
  constructor(cdrInsightService: CdrInsightsService) {
    super(soliticsconfig[window.GLOBALS.LICENSE_TYPE].insights.solitics, cdrInsightService);
  }

  async build() {
    // no-op
  }
}
